import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { apiRequest } from "@/lib/queryClient";

/** Display permission only; each admin API enforces its own server guard. */
export function useAdminAccess(): boolean {
  const { userId, isLoaded, isSignedIn } = useAuth();
  const enabled = isLoaded && isSignedIn && !!userId;
  const { data, isSuccess } = useQuery({
    queryKey: ["/api/me/admin-access", userId],
    queryFn: async () => {
      const response = await apiRequest("GET", "/api/me/admin-access");
      return await response.json() as { admin?: unknown } | null;
    },
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: true,
  });

  return enabled && isSuccess && data?.admin === true;
}
